import { Stack } from "@mui/material";
import { PrimaryEditLink, phoneNumberMasker } from "react-common-ui-library";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  COLON_SYMBOL,
  EMPTY_STRING,
  NAME_AND_CONTACT_ROUTE,
  SPACING_2_5__2,
  SPACING_4_3,
  SUBTITLE,
  EMAIL,
  ACCOUNT_CREATION_ROUTE,
  LOCALE_EN,
} from "../../../Constants/CommonConstants";
import {
  REVIEW_YOUR_INFORMATION_DATE_OF_BIRTH,
  REVIEW_YOUR_INFORMATION_EDIT,
  REVIEW_YOUR_INFORMATION_EMAIL_LANGUAGE_LABEL,
  REVIEW_YOUR_INFORMATION_FIRST_NAME,
  REVIEW_YOUR_INFORMATION_LAST_NAME,
  REVIEW_YOUR_INFORMATION_NAME_AND_CONTACT_SECTION,
  REVIEW_YOUR_INFORMATION_NAME_AND_CONTACT_SECTION_EDIT,
  REVIEW_YOUR_INFORMATION_VERIFICATION_METHOD,
} from "../../../Constants/ReviewYourInformationConstants";
import { manageAccountCreationSelector } from "../../../Selectors/AccountCreationSelector";
import { StyledReviewSectionHeader } from "../../../Styles/AccountCreation/ReviewYourInformation/ReviewYourInformationStyles";
import { StyledTypographyHeader } from "../../../Styles/Common/CommonStyles";
import ReviewFieldDisplay from "./ReviewFieldDisplay";
import { manageLocaleSelector } from "../../../Selectors/LocaleSelector";

/**
 * @description contains information that is saved in  Name and contact page.
 * @returns {ReactNode} Render the Name and contact section with First name, Last name, Date of birth, Preferred verification method, Phone number or Email.
 */
const ReviewNameAndContactSection = () => {
  const navigate = useNavigate();

  const intl = useIntl();

  const {
    firstName,
    lastName,
    dateOfBirth,
    preferredContact,
    email,
    phone,
    emailLanguage,
  } = useSelector((state) => manageAccountCreationSelector(state));
  const { language } = useSelector((state) => manageLocaleSelector(state));

  const navigateToNameAndContactPage = () => {
    navigate(`/${ACCOUNT_CREATION_ROUTE}/${NAME_AND_CONTACT_ROUTE}`);
  };

  return (
    <Stack gap={SPACING_4_3}>
      <StyledReviewSectionHeader>
        <StyledTypographyHeader
          id={REVIEW_YOUR_INFORMATION_NAME_AND_CONTACT_SECTION}
          variant={SUBTITLE}
          fontWeight={600}
        >
          {intl.formatMessage({
            id: REVIEW_YOUR_INFORMATION_NAME_AND_CONTACT_SECTION,
          })}
        </StyledTypographyHeader>
        <PrimaryEditLink
          onClick={navigateToNameAndContactPage}
          label={intl.formatMessage({ id: REVIEW_YOUR_INFORMATION_EDIT })}
          id={REVIEW_YOUR_INFORMATION_NAME_AND_CONTACT_SECTION_EDIT}
        />
      </StyledReviewSectionHeader>
      <Stack gap={SPACING_2_5__2}>
        <ReviewFieldDisplay
          fieldLabelId={REVIEW_YOUR_INFORMATION_FIRST_NAME}
          fieldData={firstName}
        />
        <ReviewFieldDisplay
          fieldLabelId={REVIEW_YOUR_INFORMATION_LAST_NAME}
          fieldData={lastName}
        />
        <ReviewFieldDisplay
          fieldLabelId={REVIEW_YOUR_INFORMATION_DATE_OF_BIRTH}
          fieldData={dateOfBirth}
        />
        <ReviewFieldDisplay
          fieldLabelId={REVIEW_YOUR_INFORMATION_VERIFICATION_METHOD}
          fieldData={intl
            .formatMessage({
              id: `review-your-information-${preferredContact}`,
            })
            ?.replace(COLON_SYMBOL, EMPTY_STRING)}
        />
        <ReviewFieldDisplay
          fieldLabelId={`review-your-information-${preferredContact}`}
          fieldData={
            preferredContact === EMAIL ? email : phoneNumberMasker(phone)
          }
        />
        {preferredContact === EMAIL ? (
          <ReviewFieldDisplay
            fieldLabelId={REVIEW_YOUR_INFORMATION_EMAIL_LANGUAGE_LABEL}
            fieldData={
              language === LOCALE_EN
                ? emailLanguage?.displayEn
                : emailLanguage?.displayEs
            }
          />
        ) : null}
      </Stack>
    </Stack>
  );
};

export default ReviewNameAndContactSection;
